<!--
  线下充值选择银行卡
  lovi 2020-1-10
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="data.title"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />

    <div class="scroll-wrapper">
      <scroll>
        <van-cell-group>
          <van-cell
            :title="$t('wallet.openingBank')"
            :value="
              bank.bank_name ? bank.bank_name : $t('wallet.selectOpeningBank')
            "
            @click="bankCardFlag = true"
            is-link
          />
          <van-cell
            :title="$t('wallet.accountNumber')"
            :value="bank.bank_username ? bank.bank_username : '--'"
          />
          <van-cell
            :title="$t('wallet.bankCardNumber')"
            :value="bank.card_number ? bank.card_number : '--'"
          />
          <van-cell
            v-if="bank.country == 1 || bank.country == 3"
            :title="$t('common.rate')"
            :value="bank.exchange_rate"
          />
          <!-- <van-cell title="充值金额" :value="data.money" /> -->
        </van-cell-group>
        <div class="button-wrap">
          <van-button
            block
            type="primary"
            :loading="btnLoading"
            @click="confirmFun"
          >
            {{ $t("common.rechargeNow") }}
          </van-button>
        </div>
      </scroll>
    </div>

    <!-- 选择开户行 -->
    <van-popup v-model="bankCardFlag" position="bottom" get-container="body">
      <van-picker
        show-toolbar
        :title="$t('wallet.selectOpeningBank')"
        :columns="bankCardList"
        @cancel="bankCardFlag = false"
        @confirm="bankCardConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      bankCardFlag: false,
      bankCardList: [],
      bank: {},
      btnLoading: false
    };
  },
  created() {
    this._getBankList();
    this.bank = this.data.bank;
    console.log("selectBank", this.data);
  },
  mounted() {},
  computed: {},
  methods: {
    bankCardConfirm(picker, value) {
      // 选择银行
      let vm = this;
      vm.bankCardFlag = false;
      vm.bank.bank_id = picker.bank_id;
      vm.bank.bank_name = picker.bank_name;
      vm.bank.bank_username = picker.bank_username;
      vm.bank.card_number = picker.card_number;
      vm.bank.country = picker.country;
      vm.bank.exchange_rate = picker.exchange_rate;
      console.log("bankCardConfirm", value, vm.bank);
    },
    confirmFun() {
      // 确认
      let vm = this;
      if (vm.bank.bank_id == "") {
        vm.$toast(vm.$t("wallet.selectBankCard"));
        return false;
      }
      vm.btnLoading = true;
      let params = vm.data;
      params.bank_id = vm.bank.bank_id;
      params.exchange_rate = vm.bank.exchange_rate;
      vm.$post("/app/pay/bankCard_pay", params, { alert: true }).then(res => {
        vm.btnLoading = false;
        console.log("bankCard_pay", res);
        if (res.code == 0) {
          vm.$emit("getBankData", res.data);
          vm.$emit("update:selectBankFlag", false);
        } else {
          vm.$toast(res.msg);
        }
      });
    },
    _getBankList() {
      let vm = this;
      vm.$post("/app/pay/bankList", {}, { loading: true }).then(res => {
        console.log("bankList", res);
        for (let i = 0; i < res.length; i++) {
          let obj = {};
          obj = res[i];
          obj.text = res[i].bank_name;
          vm.bankCardList.push(obj);
        }
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
/deep/.van-cell {
  .van-cell__title {
    flex: initial;
    margin-right: 10px;
    div {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .icon-copy {
        margin-left: 10px;
        width: 10px;
        height: 12px;
        background: url("~@/assets/images/public/icon_copy@2x.png") no-repeat;
        background-size: 100%;
      }
    }
  }
}
</style>
